module.exports = __webpack_public_path__ + "static/media/question-mark.ca3fb7d0.png";